<section>
  <app-studentassignments *ngIf="isStudent"></app-studentassignments>
  <app-staffassignments *ngIf="!isStudent"></app-staffassignments>
</section>
